import React, { useEffect, useState, useMemo } from 'react'
import { Modal, Button } from '@imedcl/design-system'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import * as Loader from 'react-loader-spinner'
import { DataTable, Skeleton, Input } from '@imedcl/design-system'
import { ReactComponent as Check } from '../../assets/img/checked.svg'
import moment from 'moment'
import toast, { Toaster } from 'react-hot-toast'
import { ReactComponent as Error } from '../../assets/img/Group5.svg'
import { decode } from 'string-encode-decode'
import { onlyDashRut } from '@imedcl/valida-rut'

export default function ModalContent() {
  const navigate = useNavigate()
  const HOST_BACKEDN_PFP =
    process.env.REACT_APP_PFP_BACKEND || window._env_.REACT_APP_PFP_BACKEND
  const HOST_PFP_PDF =
    process.env.REACT_APP_URL_PFP_PDF || window._env_.REACT_APP_URL_PFP_PDF
  const HOST_PFP_EMAIL =
    process.env.REACT_APP_URL_PFP_EMAIL || window._env_.REACT_APP_URL_PFP_EMAIL
  const APIKEY_PRE =
    process.env.REACT_APP_APIKEY_PRE || window._env_.REACT_APP_APIKEY_PRE
  const location = useLocation()
  const [total, setTotal] = useState('')
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState()
  var [base64, setBase64] = useState()
  const [emailDisabled, setEmailDisable] = useState(false)
  const [validEmail, setValidEmail] = useState('')
  const [token, setToken] = useState()
  const [email, setEmail] = useState()
  const [loadingButtonEnviar, setLoadingButtonEnviar] = useState(false)
  const [loadingButtonDescargar, setLoadingButtonDescargar] = useState(false)
  var data = useMemo(() => [], [])
  axios.defaults.headers.common['apikey'] = `${APIKEY_PRE}`

  useEffect(() => {
    ;(async () => {
      try {
        //Validamos el token de sesión y limpiamos las almacenadas en sesión.
        let sessionActive = localStorage.getItem('session')
        if (!sessionActive) {
          navigate('/')
        } else {
          sessionStorage.clear()
        }
        const token = location.search.replace('?token=', '')
        //obtenemos la información del parametro token.
        await axios
          .get(`${HOST_BACKEDN_PFP}/v1/medPayStatusFull?medpayToken=${token}`)
          .then(async (response) => {
            if (parseInt(response.status) === 200) {
              if (response.data.status !== 'error') {
                if (response.data.data.ListVouchers.length > 0) {
                  if (response.data.data.payment_status.verbose === 'pagada') {
                    response.data.reqDocumentos.forEach((element) => {
                      let array = {}
                      array['folio'] = element.folio || 'sin datos'
                      array['fecha_emision'] =
                        moment(element.fecemision).format('DD/MM/YYYY') ||
                        'sin datos'
                      array['producto'] = element.producto || 'sin datos'
                      array['fecha_vencimiento'] =
                        moment(element.fecvencimiento).format('DD/MM/YYYY') ||
                        'sin datos'
                      array['monto'] =
                        `$${numberFormat(element.saldo)}` || 'sin datos'
                      data.push(array)
                    })
                    setToken(token)
                    setTotal(
                      `$${numberFormat(response.data.data.payments[0].amount)}`,
                    )
                    //Consultamos api pfp-pdf para obtener el pdf en base64
                    await axios
                      .post(`${HOST_PFP_PDF}/v1/pdf`, { medpayToken: token })
                      .then(async (item) => {
                        setBase64(item.data.base64)
                        //Mandamos un correo automatico la primera vez generada la vista de confirmación de pago
                        let valActiveEmail =
                          localStorage.getItem('activeFunction')
                        if (valActiveEmail && parseInt(valActiveEmail) === 1) {
                          await sendEmailAutomatic(item.data.base64, token)
                          let rt = decode(localStorage.getItem('rt'))
                          var json = {
                            ticket: response.data.nroTicket,
                            rut: onlyDashRut(rt),
                            idmedpay:
                              response.data.data.payments[0].purchase_order,
                            idmercadopago:
                              response.data.data.payments[0].external_reference,
                            tipotarjeta:
                              response.data.data.payments[0].card_type,
                          }
                          notifyPaymentQbiz(json)
                          localStorage.setItem('activeFunction', 0)
                        }
                        setLoading(false)
                        setLoadingButtonDescargar(false)
                      })
                      .catch(function (error) {
                        setBase64('error')
                        setLoadingButtonDescargar(false)
                      })
                  } else {
                    setLoading(false)
                    setError(response)
                  }
                } else {
                  setLoading(false)
                  setError(response)
                }
              } else {
                setLoading(false)
                setError(response)
              }
            } else {
              setLoading(false)
              setError(response)
            }
          })
          .catch(function (error) {
            setError(error)
          })
      } catch (error) {
        setError(error)
      }
    })()
  }, [])

  const volver = () => {
    navigate('/')
  }

  const volverImed = () => {
    window.location.replace('https://www.imed.cl/')
  }

  //Validamo si existe un base64
  const validateBase64 = (value = 0) => {
    let active = false
    if (base64) {
      if (base64 !== 'error') {
        if (value !== 1) {
          downloadPdf()
        }
      } else {
        active = true
      }
    } else {
      active = true
    }
    return active
  }

  //Hacemos la descarga del pdf.
  const downloadPdf = (base) => {
    //Si no es igual a error vamos a descargar el comprobante por que si viene el base64.
    const linkSource = base64
      ? `data:application/pdf;base64,${base64}`
      : `data:application/pdf;base64,${base}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = `${location.search.replace('?token=', '')}.pdf`
    downloadLink.click()
    setLoadingButtonDescargar(false)
    return true
  }

  //Acción del boton descargar comprobante.
  const downloadBase64File = async () => {
    setLoadingButtonDescargar(true)
    const responseBase64 = validateBase64()
    if (responseBase64) {
      //Consultamos nuevamente api pfp-pdf para obtener el pdf
      await axios
        .post(`${HOST_PFP_PDF}/v1/pdf`, { medpayToken: token })
        .then(function (response) {
          setBase64(response.data.base64)
          downloadPdf(response.data.base64)
          setLoadingButtonDescargar(false)
        })
        .catch(function (error) {
          setLoadingButtonDescargar(false)
          setBase64('error')
          toast.error(
            `Tuvimos un error al intentar descargar el comprobante, intente más tarde.`,
          )
        })
    }
  }

  //funcion que le da el formato a un precio.
  const numberFormat = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }

  //funcion que chequea el correo
  const checkEmail = (element) => {
    const regOficial = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/
    if (regOficial.test(element.target.value)) {
      setValidEmail('')
      setEmail(element.target.value)
      setEmailDisable(true)
    } else {
      setValidEmail('error')
      setEmailDisable(false)
    }
  }

  const notifyPaymentQbiz = (json) => {
    return new Promise(async (resolve, reject) => {
      await axios
        .post(`${HOST_BACKEDN_PFP}/v1/procesarPago`, json)
        .then(function (response) {
          resolve(response.data.status)
        })
        .catch(function (error) {
          resolve(error)
        })
    })
  }

  const sendEmailAutomatic = (base64Response, token) => {
    return new Promise(async (resolve, reject) => {
      actionSendEmail(base64Response, token, 0)
      resolve(true)
    })
  }

  //Funcion que hace el envio del correo
  const sendEmail = async () => {
    setLoadingButtonEnviar(true)
    try {
      //Validamos si viene existe base64.
      const valBase64 = validateBase64(1)
      if (!valBase64) {
        actionSendEmail(base64)
      } else {
        await axios
          .post(`${HOST_PFP_PDF}/v1/pdf`, { medpayToken: token })
          .then(function (response) {
            setBase64(response.data.base64)
            actionSendEmail(response.data.base64)
          })
          .catch(function (error) {
            setBase64('error')
            toast.error(
              `Tuvimos un error al intentar enviar el comprobante, intente más tarde.`,
            )
          })
      }
    } catch (error) {
      toast.error('Tuvimos un error al enviar el correo, intente más tarde.')
      setLoadingButtonEnviar(false)
    }
  }

  const actionSendEmail = async (
    codeBase64,
    tokenFunction = '',
    validJson = 1,
  ) => {
    let code
    let json
    if (tokenFunction === '') {
      code = token
    } else {
      code = tokenFunction
    }
    if (validJson === 1) {
      json = {
        medpayToken: code,
        emailForwarding: email,
        forwarding: 1,
        base64: codeBase64,
      }
    } else {
      json = { medpayToken: code, base64: codeBase64 }
    }
    const response = await axios.post(`${HOST_PFP_EMAIL}/v1/sendMail`, json)
    if (response.status === 200) {
      toast.success('E-mail enviado correctamente!')
      setLoadingButtonEnviar(false)
    } else {
      toast.error('Tuvimos un error al enviar el correo, intente más tarde.')
      setLoadingButtonEnviar(false)
    }
  }

  return (
    <>
      {!error ? (
        <div className='flex m-5 mb-20 items-center justify-center'>
          <div className='shadow-lg bg-white '>
            <div className=' shadow-lg bg-white border-t-8 rounded border-success'>
              <div>
                <Toaster position='top-right' reverseOrder={false} />
              </div>
              <div>
                {!loading ? (
                  <div>
                    <div className=' mb-6 bg-success h-13'>
                      <div className='flex flex-row items-center justify-center'>
                        <div className='text-center text-xl text-white'>
                          <h1 className='mt-2'>
                            Tu pago se procesó con éxitos!
                          </h1>
                        </div>
                        <Check className='ml-2' width={35} />
                      </div>
                    </div>
                    <div className=''>
                      <h2 className='text-center text-xl text-secondary-imed-100 mb-1 mt-1'>
                        <span className='mr-8'>Monto total pagado:</span>{' '}
                        <strong>
                          <span className='ml-10'>{total}</span>
                        </strong>
                      </h2>
                    </div>
                    <div>
                      <p className='text-s text-secondary-imed-100 mt-10 ml-5'>
                        Resumen de facturas pagadas
                      </p>
                    </div>
                    <div className='mt-4 mx-5'>
                      <DataTable
                        className='ml-5 mr-5'
                        columns={[
                          {
                            Header: () => (
                              <span className='text-neutral-80 tracking-normal font-medium w-32'>
                                <strong>Fecha emisión</strong>
                              </span>
                            ),
                            accessor: 'fecha_emision',
                            HeaderWidth: 'w-[20%]',
                            skeleton: (
                              <Skeleton customClass='w-[70%] h-4 pl-4 m-auto mt-1 mb-1' />
                            ),
                            Cell: ({ value, row }) => {
                              return (
                                <span className='text-neutral-80 tracking-normal font-light'>
                                  {value}
                                </span>
                              )
                            },
                            filter: 'exact',
                            sortDescFirst: false,
                          },
                          {
                            Header: () => (
                              <span className='text-neutral-80 tracking-normal font-medium'>
                                <strong>Folio</strong>
                              </span>
                            ),
                            accessor: 'folio',
                            HeaderWidth: 'w-[20%]',
                            skeleton: (
                              <Skeleton customClass='w-[70%] h-4 pl-4 m-auto mt-1 mb-1' />
                            ),
                            Cell: ({ value, row }) => {
                              return (
                                <span className='text-neutral-80 tracking-normal font-light'>
                                  {value}
                                </span>
                              )
                            },
                            filter: 'exact',
                            sortDescFirst: false,
                          },
                          {
                            Header: () => (
                              <span className='text-neutral-80 tracking-normal font-medium'>
                                <strong>Producto</strong>
                              </span>
                            ),
                            accessor: 'producto',
                            HeaderWidth: 'w-[40%]',
                            skeleton: (
                              <Skeleton customClass='w-[70%] h-4 pl-4 m-auto mt-1 mb-1' />
                            ),
                            Cell: ({ value, row }) => {
                              return (
                                <span className='text-neutral-80 tracking-normal font-light'>
                                  {value}
                                </span>
                              )
                            },
                            filter: 'exact',
                            sortDescFirst: false,
                          },
                          {
                            Header: () => (
                              <span className='text-neutral-80 tracking-normal font-medium w-40'>
                                <strong>Fecha vencimiento</strong>
                              </span>
                            ),
                            accessor: 'fecha_vencimiento',
                            HeaderWidth: 'w-[20%]',
                            skeleton: (
                              <Skeleton customClass='w-[70%] h-4 pl-4 m-auto mt-1 mb-1' />
                            ),
                            Cell: ({ value, row }) => {
                              return (
                                <span className='text-neutral-80 tracking-normal font-light'>
                                  {value}
                                </span>
                              )
                            },
                            filter: 'exact',
                            sortDescFirst: false,
                          },
                          {
                            Header: () => (
                              <span className='text-neutral-80 tracking-normal font-medium w-32'>
                                <strong>Monto</strong>
                              </span>
                            ),
                            accessor: 'monto',
                            HeaderWidth: 'w-[20%]',
                            skeleton: (
                              <Skeleton customClass='w-[70%] h-4 pl-4 m-auto mt-1 mb-1' />
                            ),
                            Cell: ({ value, row }) => {
                              return (
                                <span className='text-neutral-80 tracking-normal font-light'>
                                  {value}
                                </span>
                              )
                            },
                            filter: 'exact',
                            sortDescFirst: false,
                          },
                        ]}
                        data={data}
                        fetchData={function noRefCheck() {}}
                        hideFilter
                        hidePagination
                        orderBy='folio'
                        renderRowSubComponent={function noRefCheck() {}}
                        statusName='folio'
                        tableFilterStatus={function noRefCheck() {}}
                        totalResults={data.length}
                      />
                    </div>
                    <div className='mt-5'>
                      <p className='text-s text-secondary-imed-100 mt-10 ml-5'>
                        ¿Qué te gustaría hacer con el comprobante?
                      </p>
                    </div>
                    <div className='flex items-end justify-center mt-8'>
                      <div className='flex flex-row items-end justify-center gap-4'>
                        <div className='ml-4'>
                          <Input
                            focused
                            name='email'
                            placeholder='ingrese correo electrónico'
                            stateMessage='Correo ingresado inválido'
                            title='Correo electrónico'
                            stateType={validEmail}
                            type='text'
                            customSize='m'
                            onChange={checkEmail}
                          />
                        </div>
                        {!emailDisabled ? (
                          <div>
                            {!loadingButtonEnviar ? (
                              <div className='mt-2'>
                                <Button
                                  className='m-0'
                                  type='secondary'
                                  disabled>
                                  {' '}
                                  Enviar{' '}
                                </Button>
                              </div>
                            ) : (
                              <div className='mt-2'>
                                <Button
                                  className='m-4'
                                  type='secondary'
                                  disabled>
                                  {' '}
                                  Enviando correo..{' '}
                                </Button>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div className='mt-2'>
                            <Button
                              className='m-0'
                              type='secondary'
                              onClick={sendEmail}>
                              {' '}
                              Enviar{' '}
                            </Button>
                          </div>
                        )}
                        <div className='mt-2'>
                          <Button
                            className='m-0'
                            type='secondary'
                            onClick={downloadBase64File}
                            loading={loadingButtonDescargar}
                            loadingText='Descargando comprobante'>
                            {' '}
                            Descargar comprobante{' '}
                          </Button>
                        </div>

                        <div className='mt-2'>
                          <Button
                            className='m-0 mr-4'
                            type='secondary'
                            onClick={volverImed}>
                            {' '}
                            Finalizar{' '}
                          </Button>
                        </div>
                      </div>
                    </div>
                    <br></br>
                  </div>
                ) : (
                  <div className='w-[800px] mx-auto p-10'>
                    <div className='flex items-center justify-center'>
                      <h2 className='text-center text-xl text-secondary-imed-100'>
                        Cargando datos..
                      </h2>
                    </div>
                    <div className='mt-5 text-center'>
                      <Loader.TailSpin
                        wrapperClass='justify-center'
                        color='#3183F2'
                      />
                    </div>
                    <br></br>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='mt-8'>
          <Modal backgroundClassName='!relative'>
            <React.Fragment key='.0'>
              <div className='mb-6  flex items-center justify-center '>
                <Error width={200}></Error>
              </div>
              <div className='mb-6  flex items-center justify-center '>
                <h2 className='text-center text-xl text-secondary-imed-100'>
                  No se encontró una sesión con el token especificado.
                </h2>
              </div>
              <div className='mb-6  flex items-center justify-center '>
                <h2 className='text-center text-xl text-secondary-imed-100'>
                  <div className='flex items-center justify-center'>
                    <Button className='m-4' type='secondary' onClick={volver}>
                      Finalizar
                    </Button>
                  </div>
                </h2>
              </div>
            </React.Fragment>
          </Modal>
        </div>
      )}
    </>
  )
}
